"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "factions", {
    enumerable: true,
    get: function() {
        return factions;
    }
});
const factions = [
    {
        id: "judgment-day",
        name: "The Judgment Day",
        image: "//www.wwe.com/f/styles/network2_search_400w/public/2023/10/20231020_SD_RAW2--31878e989a6b419848f8f344b8b3e9bb.jpg",
        brandIds: [
            "raw",
            "smackdown"
        ],
        backgroundColor: "#4b0260",
        color: "#fff",
        wrestlerIds: [
            "finn-balor",
            "dominik-mysterio",
            "damian-priest",
            "jd-mcdonagh"
        ]
    },
    {
        id: "new-catch-republic",
        name: "New Catch Republic",
        brandIds: [
            "raw",
            "smackdown"
        ],
        backgroundColor: "#4b0260",
        color: "#fff",
        wrestlerIds: [
            "pete-dunne",
            "tyler-bate"
        ]
    },
    {
        id: "the-elite",
        name: "The Elite",
        brandIds: [
            "dynamite",
            "collision"
        ],
        backgroundColor: "#000",
        color: "#fff",
        wrestlerIds: [
            "kennyomega",
            "matt-jackson",
            "nick-jackson"
        ]
    },
    {
        id: "los-lotharios",
        name: "Los Lotharios",
        brandIds: [
            "nxt"
        ],
        backgroundColor: "#000",
        color: "#fff",
        leaderIds: [
            "santos-escobar"
        ],
        wrestlerIds: [
            "angel-garza",
            "humberto-carrillo"
        ]
    },
    {
        id: "awesome-truth",
        name: "Awesome Truth",
        brandIds: [
            "raw"
        ],
        backgroundColor: "#000",
        color: "#fff",
        wrestlerIds: [
            "the-miz",
            "r-truth"
        ]
    },
    {
        id: "bloodline",
        name: "The Bloodline",
        image: "//www.wwe.com/f/styles/wwe_16_9_s/public/all/2023/04/WM39_Final--690c21f851e821e98d850f22a65e791e.jpg",
        brandIds: [
            "smackdown"
        ],
        backgroundColor: "#000",
        color: "red",
        leaderIds: [
            "roman-reigns"
        ],
        wrestlerIds: [
            "solo-sikoa"
        ],
        managerIds: [
            "paul-heyman"
        ]
    },
    {
        id: "creed",
        name: "Creed Brothers",
        image: "//www.wwe.com/f/styles/network2_search_400w/public/2023/08/20230822_Heatwave_Creed--c47e688da0e886e3b62d9744019e9d28.jpg",
        brandIds: [
            "raw"
        ],
        backgroundColor: "#358ab9",
        color: "white",
        wrestlerIds: [
            "julius-creed",
            "brutus-creed"
        ],
        managerIds: [
            "ivy-nile"
        ]
    },
    {
        id: "new-day",
        name: "The New Day",
        brandIds: [
            "raw"
        ],
        backgroundColor: "#358ab9",
        image: "//www.wwe.com/f/styles/network2_search_400w/public/all/2021/06/___NEWDAY_01272019sb_0597--77f7c6d651bc79cb8f63df1ff12ed2a9.jpg",
        color: "#fff",
        managerIds: [
            "big-e"
        ],
        wrestlerIds: [
            "kofi-kingston",
            "xavier-woods"
        ]
    },
    {
        id: "damage-control",
        name: "Damage Control",
        image: "//www.wwe.com/f/styles/network2_search_400w/public/2022/09/ahoreep_nologo--8ad2566b5e0a1a68df7121d397f1e2dd.jpg",
        backgroundColor: "#000",
        brandIds: [
            "smackdown"
        ],
        color: "#fff",
        wrestlerIds: [
            "asuka",
            "bayley",
            "kairi-sane",
            "iyo-sky",
            "dakota-kai"
        ]
    },
    {
        id: "brawling-brutes",
        name: "Brawling Brutes",
        image: "//www.wwe.com/f/styles/gallery_img_l/public/all/2022/10/001_RULES_10082022RF_29767--565ac49c9921ef127ca4ff52c2543e9a.jpg",
        color: "#fff",
        backgroundColor: "#000",
        brandIds: [
            "smackdown"
        ],
        wrestlerIds: [
            "butch",
            "sheamus"
        ]
    },
    {
        id: "imperium",
        name: "Imperium",
        backgroundColor: "#fff",
        color: "#000",
        brandIds: [
            "raw"
        ],
        leaderIds: [
            "gunther"
        ],
        wrestlerIds: [
            "ludwig-kaiser",
            "giovanni-vinci"
        ]
    },
    {
        id: "diy",
        name: "DIY",
        brandIds: [
            "raw"
        ],
        color: "#fff",
        backgroundColor: "#333",
        leaderIds: [],
        wrestlerIds: [
            "johnny-gargano",
            "tommaso-ciampa"
        ]
    },
    {
        id: "pretty-deadly",
        name: "Pretty Deadly",
        brandIds: [
            "smackdown"
        ],
        backgroundColor: "hotpink",
        image: "//www.wwe.com/f/styles/network2_search_400w/public/2023/10/20231013_SDLowdown_thumb--4a95c93f869f20ae6401e8a69b22dc0f.jpg",
        color: "#000",
        wrestlerIds: [
            "elton-prince",
            "kit-wilson"
        ]
    },
    {
        id: "piper-green",
        name: "Piper Green",
        brandIds: [
            "raw"
        ],
        wrestlerIds: [
            "piper-niven",
            "chelsea-green"
        ]
    },
    {
        id: "alpha-academy",
        name: "Alpha Academy",
        color: "#fff",
        backgroundColor: "#000",
        image: "//www.wwe.com/f/styles/wwe_16_9_l_FC/public/2023/03/20230327_RAW_Otis--70bd3cd77cc86167034e0e435158dcdb.jpg",
        brandIds: [
            "raw"
        ],
        wrestlerIds: [
            "otis",
            "chad-gable"
        ]
    },
    {
        id: "kabuki-warriors",
        name: "Kabuki Warriors",
        brandIds: [
            "smackdown"
        ],
        wrestlerIds: [
            "asuka",
            "kairi-sane"
        ]
    },
    {
        id: "good-brothers",
        name: "Good Brothers",
        brandIds: [
            "raw"
        ],
        wrestlerIds: [
            "karl-anderson",
            "luke-gallows"
        ],
        managerIds: [
            "michin"
        ]
    },
    {
        id: "british-strong-style",
        name: "British Strong Style",
        brandIds: [
            "smackdown"
        ],
        wrestlerIds: [
            "tyler-bate",
            "butch"
        ]
    },
    {
        id: "dawn-fire",
        name: "Dawn Fire",
        brandIds: [
            "smackdown"
        ],
        wrestlerIds: [
            "alba-fyre",
            "isla-dawn"
        ]
    },
    {
        id: "hart-nox",
        name: "Hart Nox",
        brandIds: [
            "raw"
        ],
        wrestlerIds: [
            "natalya",
            "tegan-nox"
        ]
    },
    {
        id: "tap-out",
        name: "Tap Out",
        brandIds: [
            "raw"
        ],
        wrestlerIds: [
            "zoey-stark",
            "shayna-baszler"
        ]
    },
    {
        id: "legado-del-fantasma",
        name: "LWO",
        color: "#fff",
        backgroundColor: "#333",
        brandIds: [
            "smackdown"
        ],
        leaderIds: [
            "rey-mysterio"
        ],
        wrestlerIds: [
            "carlito",
            "raul-mendoza",
            "joaquin-wilde",
            "cruz-del-toro",
            "zelina-vega"
        ]
    },
    {
        id: "street-profits",
        name: "Street Profits",
        color: "#fff",
        backgroundColor: "#000",
        brandIds: [
            "smackdown"
        ],
        leaderIds: [
            "bobby-lashley"
        ],
        wrestlerIds: [
            "angelo-dawkins",
            "montez-ford"
        ]
    },
    {
        id: "ft",
        name: "Final Testament",
        image: "//www.wwe.com/f/styles/wwe_large/public/all/2020/05/Scarlet_Bordeaux_Bio--8a2406e5825107c6518662ce20333df2.jpg",
        color: "#fff",
        backgroundColor: "#000",
        brandIds: [
            "smackdown"
        ],
        leaderIds: [
            "karrion-kross"
        ],
        wrestlerIds: [
            "akam",
            "rezar"
        ],
        managerIds: [
            "scarlett",
            "paul ellering"
        ]
    },
    {
        id: "carter-chance",
        name: "Carter Chance",
        color: "#fff",
        backgroundColor: "#000",
        brandIds: [
            "raw"
        ],
        wrestlerIds: [
            "kayden-carter",
            "katana-chance"
        ]
    },
    {
        id: "the-hardys",
        name: "The Hardy's",
        color: "#fff",
        backgroundColor: "#000",
        brandIds: [
            "dynamite",
            "collision"
        ],
        wrestlerIds: [
            "jeffhardy",
            "matthardy"
        ]
    },
    {
        id: "frt",
        name: "FTR",
        color: "#fff",
        backgroundColor: "#000",
        brandIds: [
            "dynamite",
            "collision",
            "ring-of-honor"
        ],
        wrestlerIds: [
            "cash-wheeler",
            "dax-harwood"
        ]
    },
    {
        id: "young-bucks",
        name: "The Young Bucks",
        color: "#fff",
        backgroundColor: "#000",
        brandIds: [
            "dynamite",
            "collision",
            "ring-of-honor"
        ],
        wrestlerIds: [
            "nick-jackson",
            "matt-jackson"
        ]
    },
    {
        id: "bcc",
        name: "Blackpool Combat Club",
        color: "#fff",
        backgroundColor: "#000",
        brandIds: [
            "collision",
            "dynamite"
        ],
        wrestlerIds: [
            "jonmoxley",
            "bryandanielson",
            "wheeler-yuta"
        ]
    },
    {
        id: "bullet-club",
        name: "Bullet Club",
        color: "#fff",
        backgroundColor: "#000",
        brandIds: [
            "collision",
            "dynamite"
        ],
        leaderIds: [
            "jay-white"
        ],
        wrestlerIds: [
            "coltongunn",
            "austingunn",
            "juice-robinson"
        ]
    },
    {
        id: "the-gunns",
        name: "Gunn Brothers",
        color: "#fff",
        backgroundColor: "#000",
        brandIds: [
            "collision",
            "dynamite"
        ],
        wrestlerIds: [
            "coltongunn",
            "austingunn"
        ]
    },
    {
        id: "house-of-black",
        name: "House of Black",
        color: "#fff",
        backgroundColor: "#000",
        brandIds: [
            "dynamite"
        ],
        leaderIds: [
            "malakai-black"
        ],
        wrestlerIds: [
            "brodyking",
            "buddy-matthews"
        ]
    },
    {
        id: "the-acclaimed",
        name: "The Acclaimed",
        color: "#fff",
        backgroundColor: "#000",
        brandIds: [
            "dynamite"
        ],
        wrestlerIds: [
            "anthony-bowens",
            "max-caster"
        ],
        managerIds: [
            "billy-gunn"
        ]
    }
];
